/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import Modal from '../../../../../components/Modal/Modal';
import { GhostButton, DangerButton } from '../../../../../styles/ui/Button';
import { FormGrid } from '../../../../../styles/layout/FormGrid';
import { Field } from '../../../../../styles/forms/Field';
import { disqualifyOnboarding } from '../../../../../services/hr/recruitment/onboardingApi';
import { recruitmentErrorMessage } from '../../utils/apiError';

// ---------------------------------------------------------------------------
// Desqualificar o candidato durante o onboarding (ação destrutiva/terminal —
// onboarding → DESQUALIFICADO, candidato → ENCERRADO). Motivo é opcional no
// contrato, mas incentivado pelo placeholder. Disponível em qualquer etapa
// antes de ADMITIDO.
// ---------------------------------------------------------------------------

export default function DisqualifyModal({
   isOpen,
   onClose,
   onboarding,
   onSaved,
}) {
   const [reason, setReason] = useState('');
   const [isSubmitting, setIsSubmitting] = useState(false);

   useEffect(() => {
      if (isOpen) {
         setReason('');
         setIsSubmitting(false);
      }
   }, [isOpen]);

   const handleConfirm = async () => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      try {
         const { message } = await disqualifyOnboarding(
            onboarding.id,
            reason.trim(),
         );
         toast.success(message);
         onSaved?.();
         onClose?.();
      } catch (err) {
         toast.error(
            recruitmentErrorMessage(err, 'Erro ao desqualificar o candidato.'),
         );
      } finally {
         setIsSubmitting(false);
      }
   };

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         title="Desqualificar candidato"
         maxWidth="480px"
         footer={
            <>
               <GhostButton
                  type="button"
                  onClick={onClose}
                  disabled={isSubmitting}
               >
                  Cancelar
               </GhostButton>
               <DangerButton
                  type="button"
                  onClick={handleConfirm}
                  disabled={isSubmitting}
               >
                  {isSubmitting ? 'Desqualificando…' : 'Desqualificar candidato'}
               </DangerButton>
            </>
         }
      >
         <p style={{ margin: '0 0 12px', fontSize: '0.9rem' }}>
            O onboarding será encerrado como <strong>desqualificado</strong> e o
            candidato sai do processo. Esta ação não pode ser desfeita.
         </p>
         <FormGrid>
            <Field className="col-12">
               <label htmlFor="disqualify-reason">Motivo (opcional)</label>
               <textarea
                  id="disqualify-reason"
                  rows={3}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  disabled={isSubmitting}
                  placeholder="Ex.: reprovado na análise de antecedentes."
               />
            </Field>
         </FormGrid>
      </Modal>
   );
}

DisqualifyModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   onboarding: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   }),
   onSaved: PropTypes.func,
};
